import { Navigate, Route } from 'react-router-dom';
import LandingPage from '../pages/LandingPage';
import MarketingDocPage from '../pages/MarketingDocPage';
import MarketingFaqPage from '../pages/MarketingFaqPage';
import WaitingListPage from '../pages/WaitingListPage';

export function marketingRoutes(marketingEnabled: boolean) {
  if (!marketingEnabled) {
    return (
      <>
        <Route path="/landing" element={<Navigate to="/" replace />} />
        <Route path="/waiting-list" element={<Navigate to="/" replace />} />
        <Route path="/support" element={<Navigate to="/" replace />} />
        <Route path="/faq" element={<Navigate to="/" replace />} />
        <Route path="/impressum" element={<Navigate to="/" replace />} />
        <Route path="/datenschutz" element={<Navigate to="/" replace />} />
        <Route path="/nutzungsbedingungen" element={<Navigate to="/" replace />} />
        <Route path="/cookie-richtlinie" element={<Navigate to="/" replace />} />
      </>
    );
  }

  return (
    <>
      <Route path="/landing" element={<LandingPage />} />
      <Route path="/waiting-list" element={<WaitingListPage />} />
      <Route path="/support" element={<MarketingFaqPage />} />
      <Route path="/faq" element={<Navigate to="/support" replace />} />
      <Route path="/impressum" element={<MarketingDocPage />} />
      <Route path="/datenschutz" element={<MarketingDocPage />} />
      <Route path="/nutzungsbedingungen" element={<MarketingDocPage />} />
      <Route path="/cookie-richtlinie" element={<MarketingDocPage />} />
    </>
  );
}
